import { AxiosRequestConfig } from 'axios'

const getMembershipsPrizes = (membershipId?: number): AxiosRequestConfig => {
  if (membershipId) {
    return {
      url: `/memberships/${membershipId}/prizes`,
      method: 'GET',
    }
  }

  return {
    url: '/prizes/with-memberships',
    method: 'GET',
  }
}

export { getMembershipsPrizes }
